import ProductSubscriptionsReducer from "@aihCustomBlueprint/Store/Data/AihCustomProductSubscribe/ProductSubscribeReducer";
import DataState from "@aihCustomBlueprint/Store/Data/DataState";
import GiftCardReducer from "@aihCustomBlueprint/Store/Data/GiftCard/GiftCardReducer";
import ReviewCartLineReducer from "@aihCustomBlueprint/Store/Data/ReviewCartLine/ReviewCartLineReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

export default interface CustomApplicationState extends ApplicationState {
    readonly AIHState: DataState;
}

(reducers as any).GiftCards = GiftCardReducer;
(reducers as any).ReviewCartLines = ReviewCartLineReducer;
(reducers as any).ProductSubscriptions = ProductSubscriptionsReducer;

type AIHReducers = typeof reducers;

export type AIHActions = AnyAction | Parameters<AIHReducers[keyof AIHReducers]>[1];
